function cov_1ng3cijxhw() {
  var path = "/app/src/components/non-standart-learn-more/index.tsx";
  var hash = "c0c47ee726e867cc0037a8d7dc6dbf5d5088d4a5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/non-standart-learn-more/index.tsx",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c0c47ee726e867cc0037a8d7dc6dbf5d5088d4a5"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ng3cijxhw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1ng3cijxhw();
export { NonStandartLearnMore } from './non-standart-learn-more';